import React, { useEffect, useState } from 'react';
import { Button, Dialog, Input, MessagePlugin, Space } from 'tdesign-react';
import { connect } from 'react-redux';
import Form from '@/components/Form';
import RichText from '@/components/RichText';
import Text from '@/components/Text';
import { feedBackSubmit } from '@/services/feedbackService';

const { FormItem } = Form;
function Modal({ visible, handleClose, info }) {
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();

  const name = info.username || info.account;

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        user: name,
      });
    }
  }, [visible, form, name]);

  const handleSubmit = async (values) => {
    const { account } = info;
    const { user, ...others } = values;
    try {
      setSubmitting(true);
      await feedBackSubmit({ ...others, account, source: 'console' });
      MessagePlugin.success('提交成功');
      form.resetFields();
      handleClose();
    } catch (error) {
      console.trace(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      confirmBtn={{ loading: false, content: '确定' }}
      visible={visible}
      header='试用反馈'
      width={'90%'}
      placement='center'
      onClose={handleClose}
      // 标记 screenshot-modal，富文本框截图时忽略
      className='screenshot-modal'
      zIndex={10000}
      footer={
        <Space size={10}>
          <Button
            theme='default'
            variant='outline'
            onClick={() => form.resetFields(['title', 'desc'])}
          >
            重置
          </Button>
          <Button theme='default' variant='outline' onClick={handleClose}>
            取消
          </Button>
          <Button loading={submitting} theme='primary' onClick={() => form.submit()}>
            提交
          </Button>
        </Space>
      }
    >
      <Form form={form} onFinish={handleSubmit}>
        <FormItem name='user' label='用户信息'>
          <Text />
        </FormItem>
        <FormItem name='title' label='标题' rules={[{ required: true }]}>
          <Input />
        </FormItem>
        <FormItem name='detail' label='详细描述'>
          <RichText />
        </FormItem>
      </Form>
    </Dialog>
  );
}

export default connect((state) => ({
  info: state.auth.info || {},
}))(Modal);
